const CREDIT_VALUE = { cloud: 1, local: 0.05, server: 0.1 };
export default CREDIT_VALUE;